module.exports = __webpack_public_path__ + "img/user_star.6f2a3cae.svg";